module.exports = __webpack_public_path__ + "06803e0e3ce471931e80d326aa5ae7bc.svg";